import { Button, Tooltip } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useAppTheme } from '@/theme/ThemeContext'
import WaterTreeIcon from '@/assets/siderbar_icons/Circle.svg'
import {
  treeButtonHint,
  waterTreePath,
  type TreeButtonState,
} from '@/utils/premiseTree'

type Props = {
  siteId: string | undefined
  state: TreeButtonState
  noTreeHint?: string
}

const GoToWaterTreeButton = ({ siteId, state, noTreeHint }: Props) => {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'
  const navigate = useNavigate()
  const hint = treeButtonHint(state, noTreeHint)

  return (
    <Tooltip title={hint ?? ''}>
      <span>
        <Button
          variant="outlined"
          disabled={state.status !== 'found'}
          onClick={() => {
            if (state.status === 'found' && siteId)
              navigate(waterTreePath(siteId, state.treeId))
          }}
          endIcon={
            <img
              src={WaterTreeIcon}
              alt=""
              style={{
                height: 18,
                filter: isDarkMode ? 'brightness(0) invert(1)' : 'none',
                opacity: state.status === 'found' ? 1 : 0.4,
              }}
            />
          }
          dir="rtl"
          sx={{
            borderColor: isDarkMode ? '#43597F' : '#DCE6EF',
            color: isDarkMode ? '#BBD7FF' : '#003F61',
            bgcolor: isDarkMode ? 'transparent' : '#FFFFFF',
            fontFamily: 'Rubik, sans-serif',
            fontSize: 13,
            fontWeight: 400,
            textTransform: 'none',
            boxShadow: 'none',
            whiteSpace: 'nowrap',
            height: 34,
            // MUI's end-icon margin is physical, so under dir=rtl it must sit on the right of the icon.
            '& .MuiButton-endIcon': { ml: 0, mr: 1 },
            '&.Mui-disabled': {
              borderColor: isDarkMode ? '#2D3F63' : '#E2E8F0',
              color: isDarkMode ? 'rgba(187, 215, 255, 0.4)' : '#8F98A5',
            },
          }}
        >
          מעבר לעץ המים
        </Button>
      </span>
    </Tooltip>
  )
}

export default GoToWaterTreeButton
